import MuiDialogTitle from '@mui/material/DialogTitle';
import {
  type ComponentPropsWithoutRef,
  type ComponentRef,
  forwardRef,
} from 'react';

type DialogTitleProps = ComponentPropsWithoutRef<typeof MuiDialogTitle>;
type DialogTitleRef = ComponentRef<typeof MuiDialogTitle>;

const DialogTitle = forwardRef<DialogTitleRef, DialogTitleProps>(
  (props, ref) => {
    return <MuiDialogTitle ref={ref} {...props} />;
  },
);
DialogTitle.displayName = 'DialogTitle';
export default DialogTitle;
